import React from "react";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { ImgIcon } from ".";
import { downArrow } from "./icons";

export default function ImageCarousel({ images, style }) {

	const wrapper = useRef(null);
	const [position, setPosition] = useState(0);
	const [wrapperWidth, setWrapperWidth] = useState(0);

	useEffect(() => {
		function onResize() {
			if (wrapper.current) setWrapperWidth(wrapper.current.offsetWidth);
		}
		window.addEventListener("resize", onResize);
		onResize();
		return () => {
			window.removeEventListener("resize", onResize);
		}
	}, []);

	function nextImage() {
		if (position + 1 < images.length) {
			setPosition(position + 1);
		} else {
			setPosition(0);
		}
	}

	function previousImage() {
		if (position > 0) {
			setPosition(position - 1);
		} else {
			setPosition(images.length - 1);
		}
	}

	return <div
		className="imageCarousel"
		ref={wrapper}
		onClick={nextImage}
		style={{
			height: 300,
			...(style || {}),
		}}
	>
		<div className="inner v-middle" style={{
			left: -1 * wrapperWidth * position
		}}>
			{images.map(image => (
				<div
					key={image.id}
					className="image"
					style={{
						backgroundImage: `url("${image.url}")`
					}}
				/>
			))}
		</div>
		<ImgIcon
			className={`previous ${(position > 0) ? "" : "disabled"}`}
			src={downArrow}
			size={30}
			iconSize={"65%"}
			bg={"#ffffff"}
			onClick={(position > 0) ? e => {
				e.stopPropagation();
				previousImage();
			} : null}
		/>
		<ImgIcon
			className={`next ${(position + 1 < images.length) ? "" : "disabled"}`}
			src={downArrow}
			size={30}
			iconSize={"70%"}
			bg={"#ffffff"}
			onClick={(position + 1 < images.length) ? e => {
				e.stopPropagation();
				nextImage();
			} : null}
		/>
	</div>

}	